import React, { useState } from "react";
import { ChevronLeft } from "lucide-react";
import { useWorkflow } from "../../../../context/WorkflowContext";
import WorkflowListView from "./WorkflowListView";
import CreateWorkflowForm from "./CreateWorkflowForm";
import { Workflow } from "../../../../types";

const WorkflowController: React.FC = () => {
  const [selectedWorkflow, setSelectedWorkflow] = useState<Workflow | null>(null);
  const { fetchWorkflows } = useWorkflow();
  const [view, setView] = useState<"list" | "form">("list");

  const handleCreateClick = () => {
    setSelectedWorkflow(null);
    setView("form");
  };

  const handleEditClick = (workflow: Workflow) => {
    setSelectedWorkflow(workflow);
    setView("form");
  };

  const handleBackToList = () => {
    setView("list");
    setSelectedWorkflow(null);
  };

  const handleSaveComplete = () => {
    setView("list");
    setSelectedWorkflow(null);
    fetchWorkflows();
  };

  if (view === "form") {
    return (
      <div className="mx-auto w-full max-w-screen-xl p-4">
        <button
          onClick={handleBackToList}
          className="flex items-center text-violet-600 mb-4 hover:text-violet-800"
        >
          <ChevronLeft className="h-5 w-5 mr-1" />
          Back to Workflows
        </button>

        <CreateWorkflowForm
          workflowData={selectedWorkflow || undefined}
          onSave={handleSaveComplete}
          onCancel={handleBackToList}
        />
      </div>
    );
  }

  return (
    <WorkflowListView
      onCreateClick={handleCreateClick}
      onEditClick={handleEditClick}
    />
  );
};

export default WorkflowController;
